function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5 3C5 2.4375 5.4375 2 6 2C6.5625 2 7 2.4375 7 3V9.5H5V3ZM11 8C11 7.4375 11.4375 7 12 7C12.5625 7 13 7.4375 13 8V10C13 10.5625 12.5625 11 12 11C11.4375 11 11 10.5625 11 10V8ZM9 6C9.5625 6 10 6.4375 10 7V8.5C10 9.0625 9.5625 9.5 9 9.5C8.4375 9.5 8 9.0625 8 8.5V7C8 6.4375 8.4375 6 9 6ZM14 9C14 8.4375 14.4375 8 15 8C15.5625 8 16 8.4375 16 9V11C16 11.5625 15.5625 12 15 12C14.4375 12 14 11.5625 14 11V9ZM11 11.75V11.7188C11.2812 11.9062 11.625 12 12 12C12.4062 12 12.7812 11.875 13.125 11.6562C13.375 12.4375 14.125 13 15 13C15.375 13 15.7188 12.9062 16 12.7188V13C16 15.75 13.75 18 11 18H9.0625C7.75 18 6.46875 17.4688 5.53125 16.5312L5.1875 16.1875C4.4375 15.4375 4 14.4062 4 13.3438V12.5C4 11.4062 4.90625 10.5 6 10.5H8.75C9.4375 10.5 10 11.0625 10 11.75C10 12.4375 9.4375 13 8.75 13H7C6.71875 13 6.5 13.2188 6.5 13.5C6.5 13.7812 6.71875 14 7 14H8.75C10 14 11 13 11 11.75Z",
  fill: "white"
});

function SvgUserClick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserClick);
export default __webpack_public_path__ + "static/media/user-click.fec62365.svg";
export { ForwardRef as ReactComponent };